import { Directive, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { TopicLevel2TreeItem } from '../../model';

@Directive()
export abstract class TopicLevel2BadgeComponent {
  protected readonly topic = input.required<TopicLevel2TreeItem>();
  protected readonly topic$ = toObservable(this.topic);
}
